var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlagCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.03,
    height: 47.03,
    viewBox: "0 0 47.03 47.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.52,
    cy: 23.52,
    r: 21.68,
    style: {
      fill: "#c8c8c8",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "3.66451439683034px"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,15c-1.69,9.8-10.2,12-12.53,12.49a.47.47,0,0,1-.55-.49l.09-1.26a5.08,5.08,0,0,1,2.05-.24l.23-10.82c3.69,1.23,8.48.25,10.18-.17A.43.43,0,0,1,38.64,15ZM21.29,38.6a.81.81,0,0,1-.53,1l-.23,0a.79.79,0,0,1-.76-.56L13.09,16.68H13a3,3,0,1,1,3-3,2.7,2.7,0,0,1-.08.58,23.29,23.29,0,0,1,11-2.31L26.71,24.5s-3.24-.21-8.61,3.43Zm-6.83-25A1.45,1.45,0,1,0,13,15.1,1.45,1.45,0,0,0,14.46,13.65Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagCircled);
export default __webpack_public_path__ + "static/media/icon-flag-circled.db388996.svg";
export { ForwardRef as ReactComponent };